export const InputDateMask = "dd.MM.yyyy";
export const FormatDateMoment = "DD.MM.YYYY";
export const FormatDateTimeMoment = "hh:mm DD.MM.YYYY";
export const InputDatePlaceholder = "__.__.____";
export const DateLength = 13;
export const MinDate = new Date(1900, 0, 1);
export const MaxDate = new Date(2100, 0, 1);
